import nameOrContact from "./name-or-contact/name-or-contact.js";
import entityModal from "./entity-modal/entity-modal.js";
import entityAssociated from "./entity-assoc/entity-assoc.js";
import entityHeaderModal from "./entity-assoc/entity-header-modal/entity-header-modal.js";

const deps = [
	entityModal,
	entityAssociated,
	entityHeaderModal,
	nameOrContact
];

export default angular.module("vesl.components.entities", deps).name;
